import { useEffect } from 'react';

export const requestAppNavigation = (proceed) => {
  const event = new CustomEvent('rotaflex:before-navigate', { cancelable: true, detail: { proceed } });
  const accepted = window.dispatchEvent(event);
  if (accepted) proceed();
  return accepted;
};

export default function useUnsavedChanges(dirty, requestLeave) {
  useEffect(() => {
    if (!dirty) return undefined;
    const beforeUnload = (event) => { event.preventDefault(); event.returnValue = ''; };
    const beforeNavigate = (event) => { event.preventDefault(); requestLeave(event.detail.proceed); };
    window.addEventListener('beforeunload', beforeUnload);
    window.addEventListener('rotaflex:before-navigate', beforeNavigate);
    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
      window.removeEventListener('rotaflex:before-navigate', beforeNavigate);
    };
  }, [dirty, requestLeave]);
}
